<template>
    <div class="journey">
        <div
            :class="[
                'journey-header',
                { transparent: !showHeaderBackground },
                { inline: inlineHeader },
            ]">
            <span v-if="showHeader" class="journey-header-label">{{ header.label }}</span>
            <span v-if="header.date" class="journey-header-date">
                {{ header.date }}
            </span>
        </div>
        <Journey :data="data" :showDetailed="showDetailed" />
        <Addons v-if="showAddons" :segment="lastSegment" :detailed="showDetailed" />
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent, PropType } from 'vue';
    import { getLocaleWeekdayShortMonthYear } from '@shared/helpers/datetime/datetime.formatters';
    import { Journey as JourneyModel } from '@ui/components/Journey/Journey.interfaces';
    import Journey from '@ui/components/Journey/Journey.vue';
    import Addons from './Shared/Addons.vue';

    export default defineComponent({
        name: 'JourneyFerry',
        methods: { t },
        components: { Journey, Addons },
        props: {
            data: {
                type: Object as PropType<JourneyModel>,
                required: true,
            },
            showDetailed: { type: Boolean, default: false },
            showHeader: { type: Boolean, default: true },
            showAddons: { type: Boolean, default: true },
            showHeaderBackground: { type: Boolean, default: true },
            inlineHeader: { type: Boolean, default: false },
            isOutbound: { type: Boolean, default: true },
            showDivider: { type: Boolean, default: false },
        },
        setup(props) {
            const lastSegment = computed(() => {
                const count = props.data.segments.length;
                return props.data.segments[count - 1];
            });

            const header = computed(() => {
                const date = props.data.segments[0].departure.date;

                const label = t({
                    key: props.isOutbound ? 'shared.outbound_ferry' : 'shared.homebound',
                });

                return {
                    label,
                    date: date ? getLocaleWeekdayShortMonthYear(date) : null,
                };
            });

            return {
                header,
                lastSegment,
            };
        },
    });
</script>
